import React, { useState } from "react";
import { scAxiosAdmin } from "../..";
import { API_TOKEN_NAME } from "../../constants";
import { toast } from "react-toastify";

const JobApplicationForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    department: "",
    expectedSalary: "",
    resume: null,
  });
  const inputStyle = {
    width: "100%",
    borderBottom: "1px solid #B5B5B6",
    fontSize: "16px",
    outline: "none",
    borderLeft: "none",
    borderRight: "none",
    borderTop: "none",
    padding: "8px 8px 8px 0",
    textAlign: "left",
  };

  const fileInputContainerStyle = {
    borderBottom: "1px solid #B5B5B6",
    paddingBottom: ".5rem",
    width: "97%",
  };

  const fileInputStyle = {
    fontSize: "16px",
    outline: "none",
    borderLeft: "none",
    borderRight: "none",
    borderTop: "none",
    textAlign: "left",
  };

  const submitButtonStyle = {
    fontSize: "16px",
    width: "118px",
    height: "43px",
    backgroundColor: "#AF9763",
    color: "#fff",
    textTransform: "capitalize",
    border: "none",
    borderRadius: "6px",
    fontWeight: 500,
  };
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: files[0],
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const body = new FormData();
    body.append("type", "job_application");
    body.append("job_id", "");
    body.append("first_name", formData.firstName);
    body.append("last_name", formData.lastName);
    body.append("email", formData.email);
    body.append("phone_number", formData.phoneNumber);
    body.append("department", formData.department);
    body.append("expected_salary", formData.expectedSalary);
    body.append("cover_letter", ""); // Assuming you want to include this
    body.append("status", "1");
    body.append("resume", formData.resume);

    try {
      const response = await scAxiosAdmin.post("/job_applications", body, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
        },
      });

      if (response.status === 201) {
        toast.success("Application Submitted Successfully");
      }
    } catch (error) {
      toast.error("Something went wrong!");
    }
  };
  return (
    <section class="container mt-4 mb-4">
      <h3
        style={{
          color: "#AF9763",
          fontWeight: "500",
        }}
        className="text-center mb-4"
      >
        JOB APPLICATION
      </h3>
      <div
        class="row pt-5 pb-5 border justify-content-md-between"
        style={{ backgroundColor: "#FFFFFF", borderRadius: "10px" }}
      >
        <div class="col-12 d-flex">
          <form onSubmit={handleSubmit}>
            <div className="row p-3 g-5 justify-content-around w-100">
              <div className="col-md-6">
                <input
                  type="text"
                  placeholder="First Name"
                  autoComplete="off"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  placeholder="Last Name"
                  autoComplete="off"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>
              <div className="col-md-6">
                <input
                  type="email"
                  placeholder="Email Address"
                  autoComplete="off"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>
              <div className="col-md-6">
                <input
                  type="tel"
                  placeholder="Phone Number"
                  autoComplete="off"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  placeholder="Department"
                  autoComplete="off"
                  name="department"
                  value={formData.department}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>
              <div className="col-md-6">
                <input
                  type="text"
                  placeholder="Expected Salary"
                  autoComplete="off"
                  name="expectedSalary"
                  value={formData.expectedSalary}
                  onChange={handleChange}
                  style={inputStyle}
                />
              </div>
              <div className="col-md-12 px-0" style={fileInputContainerStyle}>
                <div className="d-flex justify-content-between align-items-end flex-row w-100">
                  <p>Resume/CV</p>
                  <input
                    className="w-100"
                    type="file"
                    name="resume"
                    onChange={handleChange}
                    style={fileInputStyle}
                  />
                </div>
              </div>
              <div className="col-12 d-flex justify-content-center">
                <button type="submit" style={submitButtonStyle}>
                  Apply Now
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default JobApplicationForm;



// WEBPACK FOOTER //
// ./src/component/frontend/JobApplicationForm.js